import React from 'react';
import Error404 from "../Error404";
import ChapterPage from "../ChapterPage";
import ContentPage from "../ContentPage";
import BrokerageContinuum from "../BrokerageContinuum";

export default (props) => {
    switch(props.params.slug) {
        case 'brokerage-continuum':
            return <BrokerageContinuum {...props}/>;
        case 'strive-pillars':
        case 'administration':
        case 'tips-of-the-trade-and-inspiration':
        case 'events':
        case 'roles-and-responsibilities':
            return <ChapterPage {...props}/>;
        case 'business-planning':
            return <ContentPage {...props}/>;
        default:
            return <Error404/>;
    }
}